<template>
  <vuestic-modal :show.sync="modal.show" ref="smallModal" v-bind:small="false" :cancelClass="'none'" okText="Fechar"
    cancelText="Fechar">
    <div slot="title">Informações</div>

    <div v-show="modal.load">
      <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
        <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
          </component>
        </div>
      </div>
    </div>
    <div v-show="!modal.load">
      <vuestic-tabs :names="['Dados Básicos']" ref="tabs">
        <div slot="Dados Básicos">
          <div class="row">
            <div class="col-md-8 row-break">
              <strong class="font-weight-bold">Nome:</strong><br>
              <span class="circle badge-success" v-if="modal.conteudo.flg_ativo"></span>
              <span class="circle badge-danger" v-if="!modal.conteudo.flg_ativo"></span>
              {{ modal.conteudo.nome }}
            </div>

            <div class="col-md-4">
              <strong class="font-weight-bold">AutoEscola:</strong><br>
              <template v-if="modal.conteudo.schema !== 'public'">{{ modal.conteudo.schema }}</template>
              <template v-else>Monitoramento</template>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-4">
              <strong class="font-weight-bold">CPF:</strong><br>
              {{ modal.conteudo.cpf }}
            </div>

            <div class="col-md-4">
              <strong class="font-weight-bold">Data de Nascimento:</strong><br>
              <strong v-if="modal.conteudo.data_nascimento == null" style="margin-left: 60px;">-</strong>
              <strong v-else style="margin-left: 30px;">{{ modal.conteudo.data_nascimento | DateBRFilter }}</strong>
            </div>

            <div class="col-md-4">
              <strong class="font-weight-bold">Telefone:</strong><br>
              {{ modal.conteudo.telefone }}
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-12 row-break">
              <strong class="font-weight-bold">E-mail:</strong><br>
              {{ modal.conteudo.email }}
            </div>
          </div>
        </div>
      </vuestic-tabs>
    </div>
  </vuestic-modal>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'

export default {
  name: 'InfoModal',
  components: {
    ...spinners,
  },
  data() {
    return {
      modal: {
        show: false,
        load: false,
        conteudo: {}
      },
    }
  },
  methods: {
    async open(id) {
      await this.detalhes(id)
    },
    async detalhes(id) {
      this.$refs.smallModal.open()

      this.modal.load = true

      await this.$http.get(`${urlApi}/usuarios/${id}`)
        .then((response) => {
          this.modal.conteudo = response.body.dados
        })
        .catch((err) => {
          this.$refs.smallModal.close()

          this.$toasted.show(err.body.dados, {
            position: 'top-right',
          });
        })
        .finally(() => {
          this.modal.load = false
        })
    },
  }
}
</script>

<style type="scss" scoped></style>
